import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Keyboard,
  LoadingController,
  NavController,
  NavParams
} from 'ionic-angular';
import {LoginItem} from "./login-item";
import {RegisterPage} from "../register/register";
import {PasswordForgottenPage} from "../password-forgotten/password-forgotten";
import {InitHelloPage} from "../init-hello/init-hello";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {AppVideoDetailsPage} from "../app-video-details/app-video-details";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {AppModuleListPage} from "../app-module-list/app-module-list";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {Subscription} from "rxjs";
import {StatusBar} from "@ionic-native/status-bar";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {InitPrescriptionPage} from "../init-prescription/init-prescription";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  @ViewChild(Content) public content: Content;

  item: LoginItem;
  registerPage: any = IntroWelcomePage;
  passwordForgottenPage: any = PasswordForgottenPage;

  errorVisible: boolean = false;
  serverErrorVisible: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public auth: ApiAuthProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController, private keyboard: Keyboard,  public statusBar: StatusBar, public contentTranslation: ContentTranslationProvider) {
    this.item = new LoginItem();
  }

  hideError() {
    this.errorVisible = false;
    this.serverErrorVisible = false;
  }

  login() {
    if (!this.item.email || !this.item.password) {
      this.errorVisible = true;
      return ;
    }
    let loading = this.loadingCtrl.create({
      content: this.contentTranslation.translateContent('Please wait...')
    });

    loading.present();

    let me = this;

    this.auth.login(this.item.email, this.item.password).then((res:UserStateProvider) => {
      if(res.user.status > 1) {
        me.navCtrl.setRoot(AppDashboardPage)
      } else if(!res.user.prescriptionCode) {
        me.navCtrl.setRoot(InitPrescriptionPage)
      } else {
        me.navCtrl.push(InitHelloPage);
      }
      loading.dismiss();
    }, (err) => {
      console.log(err);
      loading.dismiss();

      me.item.password = '';
      me.serverErrorVisible = true;
    })


  }

  keyboardDidShowCallback: Subscription;
  keyboardShowCallback: Subscription;
  keyboardHideCallback: Subscription;
  ionViewDidLoad() {
    var me = this;

    this.keyboardShowCallback = this.keyboard.willShow.subscribe(function() {
    }, () => {}, () => {
      me.content.scrollToBottom();
    });
    this.keyboardDidShowCallback = this.keyboard.didShow.subscribe(function() {
      setTimeout(() => {
        me.content.scrollToBottom();
      }, 50);
    });


    this.keyboardHideCallback = this.keyboard.willHide.subscribe(function() {
    });
  }

  ionViewDidLeave() {
    this.keyboardShowCallback.unsubscribe();
    this.keyboardHideCallback.unsubscribe();
    this.keyboardDidShowCallback.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts